(function () {
  'use strict';

  class BundleBuilder {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.bundlePrice = root.dataset.bundlePrice;
      this.bundleVariantId = root.dataset.bundleVariantId || null;
      this.storageKey = 'bundle-builder-' + this.sectionId;

      this.tabs = Array.from(root.querySelectorAll('[data-bundle-tab]'));
      this.panels = Array.from(root.querySelectorAll('[data-bundle-panel]'));
      this.cards = Array.from(root.querySelectorAll('[data-bundle-card]'));

      this.tray = root.querySelector('[data-bundle-tray]');
      this.trayToggle = root.querySelector('[data-tray-toggle]');
      this.trayList = root.querySelector('[data-tray-list]');
      this.trayItemsEl = root.querySelector('[data-tray-items]');
      this.trayEmptyEl = root.querySelector('[data-tray-empty]');
      this.trayCountEl = root.querySelector('[data-tray-count]');
      this.cta = root.querySelector('[data-bundle-add-to-cart]');
      this.statusEl = root.querySelector('[data-bundle-status]');

      this.selections = new Map();

      this.restore();
      this.bindTabs();
      this.bindCards();
      this.bindTray();
      this.bindCta();
      this.render();
    }

    /* ---------------- Tabs ---------------- */
    bindTabs() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
      });
    }

    activateTab(tab) {
      this.tabs.forEach((t) => {
        const isActive = t === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        const shouldShow = panel.id === tab.dataset.target;
        panel.classList.toggle('is-active', shouldShow);
        panel.hidden = !shouldShow;
      });
    }

    /* ---------------- Cards ---------------- */
    bindCards() {
      this.cards.forEach((card) => {
        const btn = card.querySelector('[data-bundle-toggle]');
        btn.addEventListener('click', () => this.toggleCard(card));
      });
    }

    toggleCard(card) {
      const variantId = card.dataset.variantId;
      if (this.selections.has(variantId)) {
        this.selections.delete(variantId);
      } else {
        this.selections.set(variantId, {
          productId: card.dataset.productId,
          variantId: variantId,
          title: card.dataset.productTitle,
          image: card.dataset.productImage,
          category: card.dataset.category,
          tabId: card.dataset.tabId
        });
      }
      this.persist();
      this.render();
    }

    /* ---------------- Tray ---------------- */
    bindTray() {
      this.trayToggle.addEventListener('click', () => {
        const expanded = this.trayToggle.getAttribute('aria-expanded') === 'true';
        this.trayToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        this.trayList.hidden = expanded;
      });
    }

    removeFromTray(variantId) {
      this.selections.delete(variantId);
      this.persist();
      this.render();
    }

    /* ---------------- Add to cart ---------------- */
    bindCta() {
      this.cta.addEventListener('click', () => this.addBundleToCart());
    }

    // async addBundleToCart() {
    //   if (this.selections.size === 0) return;

    //   this.cta.disabled = true;
    //   // const defaultLabel = this.cta.textContent;
    //   // this.cta.dataset.defaultLabel = this.cta.dataset.defaultLabel || defaultLabel;
    //   // this.cta.textContent = 'Adding…';
    //   this.cta.classList.add('is-loading');

    //   const selected = Array.from(this.selections.values());

    //   // A shared tag lets you find/report on bundle orders and, later,
    //   // hook an automatic discount to this property if you bring in one.
    //   const bundleTag = 'bundle-' + Date.now();

    //   // Every selected product becomes its own real line item.
    //   const items = selected.map((item) => ({
    //     id: item.variantId,
    //     quantity: 1,
    //     properties: {
    //       _bundle_group: bundleTag,
    //       _bundle_category: item.category
    //     }
    //   }));

    //   const cartDrawer = document.querySelector('cart-drawer');
    //   const sectionsToRender =
    //     cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
    //       ? cartDrawer.getSectionsToRender().map((section) => section.id)
    //       : ['cart-drawer', 'cart-icon-bubble'];

    //   try {
    //     const response = await fetch('/cart/add.js', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    //       body: JSON.stringify({
    //         items: items,
    //         sections: sectionsToRender,
    //         sections_url: window.location.pathname
    //       })
    //     });

    //     if (!response.ok) {
    //       const err = await response.json().catch(() => ({}));
    //       throw new Error(err.description || 'Could not add bundle to cart.');
    //     }

    //     const cartResponse = await response.json();

    //     // this.announce(items.length + ' item' + (items.length === 1 ? '' : 's') + ' added to cart.');
    //     // sessionStorage.removeItem(this.storageKey);
    //     // this.selections.clear();
    //     // this.render();


    //     // Keep selected product
    //     this.announce(items.length + ' item' + (items.length === 1 ? '' : 's') + ' added to cart.');
    //     this.render();

    //     if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
    //       cartDrawer.renderContents(cartResponse);
    //       this.clearDrawerEmptyState(cartDrawer);
    //     } else {
    //       document.dispatchEvent(new CustomEvent('cart:refresh'));
    //       window.location.href = window.location.origin + '/cart';
    //     }

    //     if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
    //       // Matches Dawn's own product-form.js flow: re-render the drawer's
    //       // sections from this response, then slide it open.
    //       cartDrawer.renderContents(cartResponse);
    //       this.clearDrawerEmptyState(cartDrawer);
    //     } else {
    //       // Cart type isn't set to "Drawer" in theme settings (or Dawn's
    //       // cart-drawer.js isn't on this page) — fall back to a visible cart.
    //       document.dispatchEvent(new CustomEvent('cart:refresh'));
    //       window.location.href = window.location.origin + '/cart';
    //     }
    //   } catch (err) {
    //     this.announce(err.message || 'Something went wrong adding your bundle. Please try again.');
    //   } finally {
    //     this.cta.classList.remove('is-loading');
    //     this.cta.disabled = this.selections.size === 0;
    //   }
    // }

    async addBundleToCart() {
      if (this.selections.size === 0) return;

      if (!this.bundleVariantId) {
        this.announce('Bundle checkout product is not configured. Please contact support.');
        return;
      }

      this.cta.disabled = true;
      this.cta.classList.add('is-loading');

      try {
        const selected = Array.from(this.selections.values());
        const newNames = selected.map((item) => item.title);

        // Check if a bundle line already exists in the cart.
        const currentCart = await fetch('/cart.js').then((r) => r.json());
        const existingLineIndex = currentCart.items.findIndex(
          (line) =>
            String(line.variant_id) === String(this.bundleVariantId) &&
            line.properties &&
            line.properties['Included in bundle'] !== undefined
        );

        const cartDrawer = document.querySelector('cart-drawer');
        const sectionsToRender =
          cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
            ? cartDrawer.getSectionsToRender().map((section) => section.id)
            : ['cart-drawer', 'cart-icon-bubble'];

        let response;

        if (existingLineIndex !== -1) {
          // A bundle line already exists — merge its included items with the
          // current selection instead of creating a second line.
          const existingLine = currentCart.items[existingLineIndex];
          const existingNames = (existingLine.properties['Included in bundle'] || '')
            .split(' | ')
            .map((s) => s.trim())
            .filter(Boolean);

          const mergedNames = existingNames.slice();
          newNames.forEach((name) => {
            if (!mergedNames.includes(name)) mergedNames.push(name);
          });

          // Keep the original bundle tag so this stays one continuous "order".
          const bundleTag = existingLine.properties._bundle_group || 'bundle-' + Date.now();

          response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              line: existingLineIndex + 1, // cart/change.js line positions are 1-indexed
              quantity: 1,
              properties: {
                'Included in bundle': mergedNames.join(' | '),
                _bundle_group: bundleTag
              },
              sections: sectionsToRender,
              sections_url: window.location.pathname
            })
          });
        } else {
          // No existing bundle line — add a new one, same as before.
          const bundleTag = 'bundle-' + Date.now();

          response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: this.bundleVariantId,
                  quantity: 1,
                  properties: {
                    'Included in bundle': newNames.join(' | '),
                    _bundle_group: bundleTag
                  }
                }
              ],
              sections: sectionsToRender,
              sections_url: window.location.pathname
            })
          });
        }

        if (!response.ok) {
          const err = await response.json().catch(() => ({}));
          throw new Error(err.description || 'Could not add bundle to cart.');
        }

        const cartResponse = await response.json();

        this.announce('Bundle added to cart.');
        this.render();

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(cartResponse);
          this.clearDrawerEmptyState(cartDrawer);
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          window.location.href = window.location.origin + '/cart';
        }
      } catch (err) {
        this.announce(err.message || 'Something went wrong adding your bundle. Please try again.');
      } finally {
        this.cta.classList.remove('is-loading');
        this.cta.disabled = this.selections.size === 0;
      }
    }

    announce(message) {
      if (this.statusEl) this.statusEl.textContent = message;
    }

    /**
     * Dawn's cart-drawer renderContents() replaces the INNERHTML of the
     * drawer's content wrapper (e.g. #CartDrawer / .drawer__inner) from the
     * sections response, but that wrapper's own `class="... is-empty"`
     * attribute isn't part of that innerHTML — it was set once, on first
     * page load, when the cart was empty. Some Dawn versions clear it
     * themselves inside renderContents(); to not depend on that, we clear
     * it ourselves, on this tick and the next couple, so it can't lose a
     * race against however the theme finishes its own render/open.
     */
    clearDrawerEmptyState(cartDrawer) {
      const clear = () => {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.removeAttribute('data-empty');
        cartDrawer.querySelectorAll('.is-empty').forEach((el) => el.classList.remove('is-empty'));
        cartDrawer.querySelectorAll('[data-empty="true"]').forEach((el) => el.setAttribute('data-empty', 'false'));
      };
      clear();
      requestAnimationFrame(clear);
      setTimeout(clear, 150);
    }

    /* ---------------- Persistence (survives reload, not required for tab switching) ---------------- */
    persist() {
      try {
        sessionStorage.setItem(this.storageKey, JSON.stringify(Array.from(this.selections.entries())));
      } catch (e) {
        /* storage unavailable — selection still works for this page view */
      }
    }

    restore() {
      try {
        const raw = sessionStorage.getItem(this.storageKey);
        if (!raw) return;
        const entries = JSON.parse(raw);
        entries.forEach(([variantId, data]) => this.selections.set(variantId, data));
      } catch (e) {
        /* ignore malformed/unavailable storage */
      }
    }

    /* ---------------- Render ---------------- */
    render() {
      // Card selected state
      this.cards.forEach((card) => {
        const variantId = card.dataset.variantId;
        const isSelected = this.selections.has(variantId);
        const btn = card.querySelector('[data-bundle-toggle]');
        const label = btn.querySelector('[data-btn-label]');
        card.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        label.textContent = isSelected ? 'Remove' : (this.addLabel || 'Add to bundle');
      });

      // Tab count badges
      const countsByTab = {};
      this.selections.forEach((item) => {
        countsByTab[item.tabId] = (countsByTab[item.tabId] || 0) + 1;
      });
      this.tabs.forEach((tab) => {
        const tabId = tab.id.replace('BundleTab-', '');
        const countEl = tab.querySelector('[data-tab-count]');
        const count = countsByTab[tabId] || 0;
        countEl.textContent = String(count);
        countEl.hidden = count === 0;
      });

      // Tray
      const total = this.selections.size;
      this.trayCountEl.textContent = String(total);
      this.trayEmptyEl.hidden = total > 0;
      this.trayItemsEl.innerHTML = '';

      this.selections.forEach((item, variantId) => {
        const li = document.createElement('li');
        li.className = 'bundle-tray__item';

        const img = document.createElement('img');
        img.src = item.image || '';
        img.alt = '';
        img.className = 'bundle-tray__item-image';
        img.width = 40;
        img.height = 40;

        const nameSpan = document.createElement('span');
        nameSpan.className = 'bundle-tray__item-title';
        nameSpan.textContent = item.title;

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'bundle-tray__remove';
        removeBtn.textContent = 'Remove';
        removeBtn.setAttribute('aria-label', 'Remove ' + item.title + ' from bundle');
        removeBtn.addEventListener('click', () => this.removeFromTray(variantId));

        li.appendChild(img);
        li.appendChild(nameSpan);
        li.appendChild(removeBtn);
        this.trayItemsEl.appendChild(li);
      });

      this.cta.disabled = total === 0;
    }
  }

  document.querySelectorAll('.bundle-builder').forEach((el) => new BundleBuilder(el));
})();